import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ConditionStyleId } from '@alltrails/maps/types/Styles';

export type ConditionsState = {
  activeCondition?: ConditionStyleId;
  isPlayingOverlay?: boolean;
  preloadedOverlayUTCs: number[];
  selectedUTC?: number; // ms
};

export const initialConditionsState: ConditionsState = {
  activeCondition: undefined,
  isPlayingOverlay: false,
  preloadedOverlayUTCs: [],
  selectedUTC: undefined
};

export const conditionsSlice = createSlice({
  name: 'conditions',
  initialState: initialConditionsState,
  reducers: {
    resetState: (
      state: ConditionsState,
      action: PayloadAction<{ persistKeys?: (keyof ConditionsState)[]; initialState?: Partial<ConditionsState> }>
    ) => {
      const newState: ConditionsState = { ...initialConditionsState, ...(action.payload.initialState || {}) };
      action.payload.persistKeys?.forEach(key => {
        const persistValue = state[key];
        (newState[key] as typeof persistValue) = persistValue;
      });

      return newState;
    },
    middlewareOnly_updateActiveCondition: (state, action: PayloadAction<ConditionStyleId | undefined>) => {
      state.activeCondition = action.payload;
    },
    updateIsPlayingOverlay: (state, action: PayloadAction<boolean>) => {
      state.isPlayingOverlay = action.payload;
    },
    addPreloadedOverlayUTC: (state, action: PayloadAction<number>) => {
      if (!state.preloadedOverlayUTCs.includes(action.payload)) {
        state.preloadedOverlayUTCs = [...state.preloadedOverlayUTCs, action.payload];
      }
    },
    updatePreloadedOverlayUTCs: (state, action: PayloadAction<number[]>) => {
      state.preloadedOverlayUTCs = action.payload;
    },
    updateSelectedUTC: (state, action: PayloadAction<number | undefined>) => {
      state.selectedUTC = action.payload;
    }
  }
});

export const {
  resetState,
  middlewareOnly_updateActiveCondition,
  updateIsPlayingOverlay,
  addPreloadedOverlayUTC,
  updatePreloadedOverlayUTCs,
  updateSelectedUTC
} = conditionsSlice.actions;

export const conditionsReducer = conditionsSlice.reducer;
